export default __webpack_public_path__ + "static/media/icon_simpro_mobile.342dda45.svg";